import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoLoginDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const styles = {
    laptop: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#333",
      borderRadius: "15px 15px 5px 5px",
      padding: "10px",
      width: "960px",
      position: "relative",
      boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    },
    screen: {
      backgroundColor: "white",
      borderRadius: "5px",
      overflow: "hidden",
      width: "100%",
      height: "500px",
    },
    container: {
      display: "flex",
      height: "100%",
    },
    leftContainer: {
      flex: 1,
      background: `linear-gradient(to right,${colors.primario}, ${colors.secundario})`,
      color: "white",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    title: {
      fontSize: "1rem",
      fontFamily: "Inter",
      fontWeight: "600",
      textAlign: "center",
      marginBottom: "20px",
    },

    rightContainer: {
      flex: 1,
      backgroundColor: "white",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "40px",
    },
    subtitle: {
      fontSize: "0.9rem",
      color: `${colors.primario}`,
      fontFamily: "Inter",
      fontWeight: "600",
      marginBottom: "20px",
    },
    inputGroup: {
      marginBottom: "20px",
      width: "80%",
    },
    label: {
      fontSize: "0.8rem",
      color: `${colors.primario}`,
      fontFamily: "Inter",
      fontWeight: "600",
      marginBottom: "8px",
    },
    input: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ddd",
      borderRadius: "4px",
      fontSize: "0.9rem",
    },
    passwordContainer: {
      display: "flex",
      position: "relative",
      alignItems: "center",
    },
    eyeButton: {
      background: "none",
      border: "none",
      position: "absolute",
      right: "20px",
      fontSize: "1.2rem",
      cursor: "pointer",
    },
    rememberMeContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "20px",
    },
    rememberMeLabel: {
      fontSize: "1rem",
      color: "gray",
      marginRight: "10px",
    },
    loginButton: {
      backgroundColor: colors.secundario,
      color: "white",
      padding: "10px 60px",
      border: "none",
      borderRadius: "4px",
      fontFamily: "Inter",
      cursor: "pointer",
      fontSize: "1rem",
    },

    base: {
      position: "absolute",
      width: "1100px",
      height: "20px",
      backgroundColor: "rgb(170, 170, 170)",
      borderRadius: "0px 0px 10px 10px",
      bottom: 0,
    },
  };

  const handleLogin = () => {
    const currentParams = location.search;
    navigate(`/backoffice-users-corporativo-web${currentParams}`);
  };

  return (
      <div style={styles.laptop}>
        <div style={styles.screen}>
          <div style={styles.container}>
            <div
                style={{
                  position: "absolute",
                  right: 20,
                  top: 20,
                  display: "flex",
                  gap: "8px",
                }}
            >
              <img
                  src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                  height={20}
                  width={20}
              />
              <img src="/img/espana.png" height={20} width={20} />
              <img src="/img/portugal.png" height={20} width={20} />
            </div>
            <div style={styles.leftContainer}>
              <h1 style={styles.title}>Welcome to VXApp Dashboard!</h1>
              <img
                  src={
                      colors.url_logo ??
                      "https://vxapp.wfsystems.com.ar/storage/logos/20240416192440.png"
                  }
                  alt="Logo"
                  style={{
                    width: 120,
                    height: "auto",
                    borderRadius: 8,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    backgroundColor: "transparent",
                  }}
              />
            </div>
            <div style={styles.rightContainer}>
              <h2 style={styles.subtitle}>
                Please, enter your personal information to begin
              </h2>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Username</label>
                <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    style={styles.input}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.label}>Password</label>
                <div style={styles.passwordContainer}>
                  <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={styles.input}
                  />
                  <div
                      style={{ ...styles.eyeButton, background: "transparent" }}
                      onClick={() => setShowPassword(!showPassword)}
                  >
                    <svg
                        width={25}
                        height={25}
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_4801_27552)">
                        <path
                            d="M2.12598 12.6537C2.12598 12.6537 6.12598 4.65369 13.126 4.65369C20.126 4.65369 24.126 12.6537 24.126 12.6537C24.126 12.6537 20.126 20.6537 13.126 20.6537C6.12598 20.6537 2.12598 12.6537 2.12598 12.6537Z"
                            stroke={colors.secundario}
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M13.126 15.6537C14.7828 15.6537 16.126 14.3105 16.126 12.6537C16.126 10.9968 14.7828 9.65369 13.126 9.65369C11.4691 9.65369 10.126 10.9968 10.126 12.6537C10.126 14.3105 11.4691 15.6537 13.126 15.6537Z"
                            stroke={colors.secundario}
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4801_27552">
                          <rect
                              width={24}
                              height={24}
                              fill="white"
                              transform="translate(0.938721 0.557495)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div style={styles.rememberMeContainer}>
                <label style={styles.rememberMeLabel}>Remember me</label>
                <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={() => setRememberMe(!rememberMe)}
                />
              </div>
              <button
                  onClick={handleLogin}
                  style={styles.loginButton}
                  className="highlighted-button "
              >
                Log In
              </button>
            </div>
          </div>
        </div>
        <div style={styles.base}></div>
      </div>
  );
};
